export default {
    //启动状态
    ready: false,
    // 页面布局
    layout: 'default',
    // 菜单折叠状态
    menuCollapse: false,
    // 字典数据
    dictData: '',
    // 用户token
    userToken: '',
    // token是否过期
    tokenExpire: false,
    // 哈希编码
    hashCode: '',
    // 用户数据
    userData: '',
    // 公司编号
    companyCode: '',
    //公司名称
    companyName: '',
    // 菜单资源
    menuResource: [],
    // 控件资源
    controlResource: [],
    // 当前主题样式
    theme: 'theme-default',
    // 公司列表
    companyList: [],
    // 委外方列表
    outSourceList: [],
    // 委托方列表
    principalList: [],
    // 部门列表
    departmentList: [],
    // 门店列表
    storeList: [],
    //批次号列表
    batchList: [],
    // 执行页类型
    collectionType: '',
    // 自定义数据字典
    customDataDict: [],
    // 数据字典哈希code
    dictHashCodeData: ''
};
